import styled from "styled-components";
import {defaultTheme} from "../../styles/themes/default";

interface ContainerProps{
    type: 'warning' | 'info';
}

const notificationTypes = {
    warning: {background: defaultTheme.yellow, color: defaultTheme.white},
    info: {background: defaultTheme.accentLightest, color: defaultTheme.accent},
}

export const Container = styled.div<ContainerProps>`
    margin-bottom: 20px;
    border-radius: 8px;
    padding: 12px 30px;
    display: flex;
    justify-content: left;
    align-items: center;
    background: ${({type}:ContainerProps) => notificationTypes[type].background};
      p{
        font-size: 14px;
        font-weight: 700;
        color: ${({type}:ContainerProps) => notificationTypes[type].color};
        @media (max-width: ${({theme}) => theme.breakpoints.md}) {
          font-size: 11px;
        }
      }
    svg {
      margin-right: 12px;
      path{
        fill: ${({type}:ContainerProps) => notificationTypes[type].color};
      }
      @media (max-width: ${({theme}) => theme.breakpoints.md}) {
        //display: none;
      }
    }
`
